"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Yup = tslib_1.__importStar(require("yup"));
exports.getValidationSchema = function (config, valuesKey) {
    var fieldValidations = Object.keys(config[valuesKey]).reduce(function (acc, nameKey) {
        var _a;
        return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[nameKey] = config[valuesKey][nameKey].validation, _a));
    }, {});
    var parentValidations = Object.keys(config).reduce(function (acc, nameKey) {
        var _a;
        return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[nameKey] = Yup.object(fieldValidations), _a));
    }, {});
    return Yup.object(parentValidations);
};
//# sourceMappingURL=getValidationSchema.js.map